exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#desc_collapse {\n\ttransition: 0.2s all;\n\tdisplay: block;\n}\n#desc_collapse.out {\n\toverflow: hidden;\n\tmax-height: 450px;\n}\n", ""]);

// exports
